import React from 'react';
import { checkPassword } from '../../../utils/passwordStrength';

const BAR_COLOURS = [
  'var(--cs-red-dark, #dc2626)',
  'var(--cs-red-dark, #dc2626)',
  'var(--cs-amber, #d97706)',
  'var(--cs-blue, #1A80E5)',
  'var(--cs-green-dark, #16a34a)',
];

/**
 * Four-segment strength meter with a text label (never colour alone).
 * Pass the same `context` (email, names) you validate with.
 */
export default function PasswordMeter({ value, context = [], id }) {
  if (!value) return null;
  const { score, label } = checkPassword(value, context);
  const filled = Math.max(1, score);
  return (
    <div id={id} style={{ marginTop: 8 }} aria-live="polite">
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 4 }} aria-hidden="true">
        {[1, 2, 3, 4].map((i) => (
          <span
            key={i}
            style={{
              height: 4,
              borderRadius: 2,
              background: i <= filled ? BAR_COLOURS[score] : 'var(--cs-border, #e5e7eb)',
            }}
          />
        ))}
      </div>
      <p style={{ margin: '4px 0 0', fontSize: 'var(--cs-text-xs, 0.75rem)', color: 'var(--cs-text-secondary, #374151)' }}>
        Strength: <strong>{label}</strong>
      </p>
    </div>
  );
}
